import Vue from 'vue'
import store from '@/store'
import routes from '@/router/routes';
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: process.env.VUE_APP_API_DOMAIN,
  routes
})

router.beforeEach(async (to, from, next) => {

  if (to.matched.some(record => record.meta.guest)) {
    if (await store.getters['auth/token']) {
      try {
        //await store.dispatch('auth/fetchUser')
      } catch (e) {
      }
    }
    next()
  } else {
    // must be authenticated...
    if (await !store.getters['auth/token']) {
      next({name: 'Login'})
    } else {

      // now check the roles
      // Routes MUST have at least one role associated in `meta: {roles:[] }`
      if (!to.matched.some(record => record.meta.roles)) {
        next({name: 'Login'})
      }

      // const userRole = store.getters['auth/user'].roles[0].name
      // to.matched.forEach(function (route) {
      //   if (route.meta.roles) {
      //     if (!route.meta.roles.includes(userRole)) {
      //       next({path: '/access-denied'})
      //     } else {
      //       next()
      //     }
      //   }
      // })
      next()
    }
  }
})

export default router
